import Styled from 'styled-components';
import Svg from '@catalogo/ui-americanas-desktop-svg/filter.svg';

const Wrapper = Styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  justify-content: end;
  padding: 12px 14px 12px 12px;
  font-size: 14px;
  color:${({ theme }) => theme.primaryColor};
`;
const Title = Styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #282828;
  line-height: 100%;
`;
const WrapperTitle = Styled.div`
padding:16px 0;
display:flex;
justify-content: space-between;
`;
const Filter = Styled(Svg)`
  fill:${({ theme }) => theme.primaryColor};
`;
const ButtonBack = Styled.button`
  border-radius: 12px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  padding: 15px;
  text-transform: ${({ theme }) => theme.titleTransform};
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-out;
  width: 100%;

  &:disabled {
    cursor: no-drop;
    opacity: 0.5;
  }

  &.primary {
    color: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.buttonPrimaryColor};
    background-color: ${({ theme }) => theme.buttonPrimaryColor};
  }

  &.secondary {
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: 1px solid ${({ theme }) => theme.buttonPrimaryColor};
    background-color: transparent;
  }

  &.text {
    font-weight: normal;
    background-color: transparent;
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: none;
  }
`;

export { Wrapper, ButtonBack, Filter, Title, WrapperTitle };
